import React, { useState, useEffect, useCallback } from 'react'
import { Radio, Table, Empty, Spin, Button } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import api from '../../api'

export default function PlayVelocityTab({ selectedAccount }) {
  const [granularity, setGranularity] = useState(2)
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)

  const loadData = useCallback(async () => {
    if (!selectedAccount?.account_id) return
    setLoading(true)
    try {
      const res = await api.getPlayVelocity({ account_id: selectedAccount.account_id, granularity })
      if (res.success) setData(res)
      else setData(null)
    } catch {
      setData(null)
    } finally {
      setLoading(false)
    }
  }, [selectedAccount, granularity])

  useEffect(() => { loadData() }, [loadData])

  if (!selectedAccount) {
    return (
      <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Empty description="请先在左侧选择一个账号" />
      </div>
    )
  }

  const slots = data?.slots || []
  const works = data?.works || []

  const slotColumns = slots.map(s => ({
    title: s.label,
    dataIndex: ['_slots', s.slot, 'plays'],
    key: `slot_${s.slot}`,
    width: 100,
    align: 'center',
    render: (_, record) => {
      const slotData = record._slots?.[s.slot]
      return slotData ? slotData.plays.toLocaleString() : '-'
    }
  }))

  const columns = [
    { title: '排名', key: 'rank', width: 60, align: 'center', fixed: 'left',
      render: (_, __, idx) => idx + 1
    },
    { title: '作品名称', dataIndex: 'work_title', key: 'title', width: 160, fixed: 'left',
      ellipsis: true
    },
    ...slotColumns,
    {
      title: '合计', key: 'total', width: 100, align: 'center', fixed: 'right',
      render: (_, record) => {
        const total = (record._slots || []).reduce((s, sl) => s + (sl.plays || 0), 0)
        return <span style={{ fontWeight: 600 }}>{total.toLocaleString()}</span>
      }
    }
  ]

  const dataSource = works.map((w, i) => ({
    ...w,
    key: w.work_id || i,
    _slots: w.slots || []
  }))

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', background: '#fff', padding: 16 }}>
      <div style={{ flexShrink: 0, marginBottom: 12, display: 'flex', alignItems: 'center', gap: 12 }}>
        <span style={{ fontSize: 13, color: '#666' }}>时间段：</span>
        <Radio.Group value={granularity} onChange={e => setGranularity(e.target.value)} size="small">
          <Radio.Button value={1}>每小时</Radio.Button>
          <Radio.Button value={2}>每2小时</Radio.Button>
          <Radio.Button value={3}>每3小时</Radio.Button>
        </Radio.Group>
        <div style={{ flex: 1 }} />
        <Button icon={<ReloadOutlined />} onClick={loadData} loading={loading} size="small">刷新</Button>
        <span style={{ fontSize: 12, color: '#999' }}>
          {works.length > 0 ? `共 ${works.length} 个作品，${slots.length} 个时段` : ''}
        </span>
      </div>

      <div style={{ flex: 1, overflow: 'auto' }}>
        <Spin spinning={loading}>
          {dataSource.length > 0 ? (
            <Table
              columns={columns}
              dataSource={dataSource}
              pagination={false}
              size="small"
              scroll={{ x: Math.max(slots.length * 100 + 400, 600) }}
              showSorterTooltip={false}
            />
          ) : (
            !loading && <Empty description="暂无播放数据" style={{ marginTop: 60 }} />
          )}
        </Spin>
      </div>
    </div>
  )
}
